

exports.__esModule = true;
exports.thirdPartyExperience = exports.venmoExperience = exports.thirdPartyInfo = undefined;

var _angular = require('angular');

var _index = require('xo-device-info/dist/index');

var _squid = require('squid');

var _auth = require('xo-models/src/auth');

var _checkout = require('xo-models/src/checkout');

var _sessionStorage = require('./sessionStorage');

var _sessionStorage2 = _interopRequireDefault(_sessionStorage);

var _logger = require('xo-beaver/dist/logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// TODO: Check how the cookie should be read/set (through meta? if read on server side)
var PWV_COOKIE = 'pwv';

var thirdPartyInfo = exports.thirdPartyInfo = {
    isThirdPartyEligible: function isThirdPartyEligible() {
        return this.isBaiduEligible() || this.isVenmoEligible();
    },
    isBaiduEligible: function isBaiduEligible() {
        var eligibility = _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token);
        return eligibility.get('baiduWallet');
    },


    // Handler to call to determine if user can use Venmo
    isVenmoEligible: function isVenmoEligible() {

        var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
        var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);

        var merchantCountry = appData.get('merchant.merchant_country');
        var isProcessorDeclined = appData.get('flags.processor_declined');
        var isInvoice = appData.get('flags.is_invoice_flow');
        var isBillingAgreement = cart.isBilling();

        var isMobile = _index.$DeviceInfo.isDevice();
        var isVenmoCookie = this.isVenmoCookiePresent();
        var isSFAuthenticationSession = _squid.$util.param('bt_int_type') === '2';
        var isMSPTransaction = cart.isMultiSellerPurchase();

        var eligibilityParams = {
            isMobile: isMobile,
            isVenmoCookie: isVenmoCookie,
            isNotInvoice: !isInvoice,
            isNotProcessorDeclined: !isProcessorDeclined,
            isNotBillingAgreement: !isBillingAgreement,
            isUSMerchant: merchantCountry === 'US',
            isNotSFAuthenticationSession: !isSFAuthenticationSession,
            isNotMSPTransaction: !isMSPTransaction
        };

        var venmoEligibility = Object.keys(eligibilityParams).filter(function (param) {
            return !eligibilityParams[param];
        });
        venmoEligibility = venmoEligibility && venmoEligibility.length > 0 ? 'ineligible:' + venmoEligibility.join() : 'eligible';

        _logger.$logger.info('venmo_eligibility', venmoEligibility);

        _logger.$logger.info('checkout_fpti', {
            'is_venmo_cookie': isVenmoCookie ? '1' : '0',
            'eligibility_reason': venmoEligibility
        });

        return Boolean(venmoEligibility === 'eligible');
    },
    isVenmoCookiePresent: function isVenmoCookiePresent() {

        var venmoRegex = new RegExp('(?:^|; )' + PWV_COOKIE + '=1(?:;|$)');
        return Boolean(document.cookie.match(venmoRegex));
    },


    // Build the venmo URL scheme
    buildVenmoURL: function buildVenmoURL() {
        var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL;
        var VENMO_ROUTE = '#/checkout/venmo';
        var LOGIN_ROUTE = '#/checkout/login?venmoError=true';

        var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);

        var params = (0, _angular.$httpParamSerializer)({
            'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
            'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
            'ua': _angular.$window.navigator.userAgent,
            'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
            'token': _angular.$rootScope.token,
            'total': cartModel.purchase.amounts.total.amount,
            'currency': cartModel.purchase.amounts.total.currency_code,
            'intent': cartModel.payment_action
        });

        return SCHEME + 'paypal/checkout?' + params;
    }
};

var venmoExperienceKey = 'VENMO_EXPERIENCE';

// Get whether a token is marked as Venmo experience.
var venmoExperience = exports.venmoExperience = {
    set: function set(token) {
        var sessionStorage = (0, _sessionStorage2['default'])();
        sessionStorage.setItem(venmoExperienceKey, token);
    },
    get: function get(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();
        if (auth.logged_in && auth.guest && // Check if Venmo guest account logged in
        sessionStorage.getItem(venmoExperienceKey) === token) {
            return true;
        } else {
            this.set(null);
            return false;
        }
    }
};

var allowedThirdPartyExperiences = {
    VENMO: 'VENMO_EXPERIENCE',
    BAIDU: 'BAIDU_EXPERIENCE'
};

var THIRD_PARTY_NAMESPSACE = 'THIRD_PARTY_EXPERIENCE';

var thirdPartyExperience = exports.thirdPartyExperience = {
    setAsVenmoExperience: function setAsVenmoExperience(token) {
        var _JSON$stringify;

        var sessionStorage = (0, _sessionStorage2['default'])();

        var payload = JSON.stringify((_JSON$stringify = {}, _JSON$stringify[token] = allowedThirdPartyExperiences['VENMO'], _JSON$stringify));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    setAsBaiduExperience: function setAsBaiduExperience(token) {
        var _JSON$stringify2;

        var sessionStorage = (0, _sessionStorage2['default'])();

        var payload = JSON.stringify((_JSON$stringify2 = {}, _JSON$stringify2[token] = allowedThirdPartyExperiences['BAIDU'], _JSON$stringify2));

        sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
    },
    isThirdPartyExperience: function isThirdPartyExperience(token) {

        var availableExperiences = [];

        for (var key in allowedThirdPartyExperiences) {
            availableExperiences.push(allowedThirdPartyExperiences[key]);
        }

        var currentExperience = this.getExperience(token);

        return Boolean(availableExperiences.indexOf(currentExperience) > -1);
    },
    getExperience: function getExperience(token) {
        var auth = _auth.$AuthModel.instance();
        var sessionStorage = (0, _sessionStorage2['default'])();

        // if logged in, and guest, we return the experience if any
        if (auth.logged_in && auth.guest && sessionStorage.getItem(THIRD_PARTY_NAMESPSACE)) {
            var payload = JSON.parse(sessionStorage.getItem(THIRD_PARTY_NAMESPSACE) || '');
            return payload && payload[token] || 'MEMBER_EXPERIENCE';
        } else {

            // If not logged in, we reset the third party experience
            this.resetThirdPartyExperience();
            return 'MEMBER_EXPERIENCE';
        }
    },
    resetThirdPartyExperience: function resetThirdPartyExperience() {
        var sessionStorage = (0, _sessionStorage2['default'])();
        sessionStorage.removeItem(THIRD_PARTY_NAMESPSACE);
    }
};

_angular.$rootScope;

_angular.$window;

_angular.$location;

_angular.$httpParamSerializer;

_index.$DeviceInfo;

_squid.$config;

_squid.$util;

_auth.$AuthModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$FlowEligibilityModel;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./components/xo-third-party-components/src/thirdParty-info/index.js
// module id = ./components/xo-third-party-components/src/thirdParty-info/index.js
// module chunks = 1